import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";

const Archivelottery = (props) => {
  const cookies = new Cookies();

  useEffect(() => {
    if (cookies.get("api_key") == null) {
      props.history.push(`/Entrance`);
    }
  }, []);

  return (
    <Link
      to={`${
        props.data.result_status
          ? "/Lottery/LotteryExpire"
          : "/Lottery/LotteryDetail"
      }/${props.data.id}`}
      className="lottery archive"
    >
      <div className="title">
        <div className="lottery-icon">
          <img src="/icons/Group 11800.svg" />
          <span>{props.data.user_rank}</span>
        </div>
        <span>{props.data.title || "موضوع نامشخص"}</span>
      </div>
      <div className="title status">
        <span>
          وضعیت شما :<b>{props.data.show_result}</b>
        </span>
      </div>
      <Link
        to={`${
          props.data.result_status
            ? "/Lottery/LotteryExpire"
            : "/Lottery/LotteryDetail"
        }/${props.data.id}`}
      >
        جزئیات قرعه کشی{" "}
        <i className="icon-arrow-down-sign-to-navigate-fill"></i>
      </Link>
    </Link>
  );
};

export default Archivelottery;
